<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow" style="display: flex;">
            <div>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
            
          </vs-dropdown>
          </div>
            <div align="center" 
                style=" display: flex;
                    align-items: center;
                    justify-content: center;
                    flex: 1;">
                <span>From&nbsp;&nbsp;&nbsp;
                    <datepicker placeholder="Select Date" v-model="datestart"></datepicker>
                    &nbsp;&nbsp;&nbsp;</span> 
                    <span>To&nbsp;&nbsp;&nbsp;
                    <datepicker placeholder="Select Date" v-model="dateend"></datepicker>
                    &nbsp;&nbsp;&nbsp;</span> &nbsp;&nbsp;&nbsp;
                    <a href="#" @click.prevent="exportExcel" v-if="!reportLoading && !reportError"><img src="https://img.icons8.com/color/452/microsoft-excel-2019--v1.png" width="50" height="50"></a>
            </div>
        </div>
        
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
         <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <!--vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="Add()">
                <span class="flex items-center">
                  <feather-icon icon="UserPlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Add</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="Delete()">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>>

            </vs-dropdown-menu>
          </!--vs-dropdown-->
      </div>


      <!-- AgGrid Table floatingFilter="true"-->
      <!--:onGridReady="onGridReady" -->
      <p v-if="reportLoading" role="status" class="mt-4">กำลังโหลดรายงาน...</p>
      <div v-if="reportError" role="alert" class="mt-4">{{ reportError }} <vs-button @click="retryReport" size="small">ลองอีกครั้ง</vs-button></div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import saleReportPage from '@/services/saleReportPage';
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Datepicker from 'vuejs-datepicker'
// Store Module
//const axios = require('axios').default;
// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererCreateDate from './cell-renderer/CellRendererCreateDate.vue'

import moment from "moment-timezone";
export default {
  mixins: [saleReportPage({action: 'fetchWithdraw', field: 'deposit', singleDate: false, daysAgo: 0, reportDayOffset: 0})],
  components: {
    AgGridVue,
    Datepicker,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererCreateDate
  },
  data () {
    return {
      
      
      showdatedefault:'',
      showdate :[],
      selected: '',
      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      roleOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ],

      statusFilter: { label: 'All', value: 'all' },
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' }
      ],

      isVerifiedFilter: { label: 'All', value: 'all' },
      isVerifiedOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'All', value: 'all' },
        { label: 'Sales', value: 'sales' },
        { label: 'Development', value: 'development' },
        { label: 'Management', value: 'management' }
      ],

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        suppressContextMenu:true,
      },
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'เวลาแจ้งถอน',
          field: 'createdate',
          width: 150,
          filter: true,
        },
        {
          headerName: 'เวลาทำถอน',
          field: 'date',
          filter: true,
          width: 150
        },
        {
          headerName: 'ID',
          field: 'code',
          filter: true,
          width: 150
        },
        {
          headerName: 'ธนาคาร',
          field: 'bank',
          filter: true,
          width: 100,
        },
        {
          headerName: 'เลขที่บัญชี',
          field: 'account_no',
          filter: true,
          width: 150
        },
        {
          headerName: 'พนักงาน',
          field: 'firstname',
          filter: true,
          width: 150
        },
        {
          headerName: 'จำนวน',
          field: 'qty',
          filter: true,
          width: 150
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererCreateDate,
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  watch: {
    
    
    roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
    
    paginationPageSize () {
      //if (this.gridApi) return this.gridApi.paginationGetPageSize() else
      return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    
    onGridReady(params){
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        window.onresize = () => {
            this.gridApi.sizeColumnsToFit();
        }
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    exportExcel(){
      const Excel = require('exceljs');
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet('mySheet');
      ws.getRow(1).height = 30
      ws.getColumn('A').width = 30;
      ws.getColumn('B').width = 30;
      ws.getColumn('C').width = 30;
      ws.getColumn('D').width = 30;
      ws.getColumn('E').width = 30;
      ws.getColumn('F').width = 30;
      ws.getColumn('G').width = 30;
      ws.getCell('A1').value = 'เวลาแจ้งถอน';
      ws.getCell('B1').value = 'เวลาทำถอน';
      ws.getCell('C1').value = 'ID';
      ws.getCell('D1').value = 'ธนาคาร';
      ws.getCell('E1').value = 'เลขที่บัญชี';
      ws.getCell('F1').value = 'พนักงาน';
      ws.getCell('G1').value = 'จำนวน';
      let i = 2;
      for(const x in this.usersData){
        ws.getCell('A'+i).value = this.usersData[x].createdate;
        ws.getCell('B'+i).value = this.usersData[x].date;
        ws.getCell('C'+i).value = this.usersData[x].code;
        ws.getCell('D'+i).value = this.usersData[x].bank;
        ws.getCell('E'+i).value = this.usersData[x].account_no;
        ws.getCell('F'+i).value = this.usersData[x].firstname;
        ws.getCell('G'+i).value = this.usersData[x].qty;
        i++;
      }

      wb.xlsx.writeBuffer( {
          base64: true
      }).then( (xls64) => {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = 'รายงานการถอน '+moment(this.datestart).format('YYYY-MM-DD')+' '+moment(this.dateend).format('YYYY-MM-DD')+ ".xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
          },50);
      })
      .catch(function(error) {
          console.log(error.message);
      });
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if(window.innerWidth>1000)
    setTimeout( ()=> this.gridApi.sizeColumnsToFit(), 0 );
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  }

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
